import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import api from './api';

const CustomerAuthCtx = createContext(null);

export function CustomerAuthProvider({ children }) {
    const [customer, setCustomer] = useState(() => {
        try { return JSON.parse(localStorage.getItem('dg_customer') || 'null'); } catch { return null; }
    });
    const [token, setToken] = useState(() => localStorage.getItem('dg_customer_token') || null);

    useEffect(() => {
        if (token && !customer) {
            api.get('/auth/customer/me', { headers: { Authorization: `Bearer ${token}` } })
                .then(r => {
                    setCustomer(r.data);
                    localStorage.setItem('dg_customer', JSON.stringify(r.data));
                }).catch(() => logout());
        }
    }, []);

    const login = (tk, cust) => {
        localStorage.setItem('dg_customer_token', tk);
        localStorage.setItem('dg_customer', JSON.stringify(cust));
        setToken(tk); setCustomer(cust);
    };

    const logout = () => {
        localStorage.removeItem('dg_customer_token');
        localStorage.removeItem('dg_customer');
        setToken(null); setCustomer(null);
    };

    const value = useMemo(() => ({
        customer, token, login, logout,
        isAuthed: !!customer,
        isWholesale: customer?.type === 'wholesale',
        level: customer?.level || 0,
    }), [customer, token]);

    return <CustomerAuthCtx.Provider value={value}>{children}</CustomerAuthCtx.Provider>;
}

export function useCustomerAuth() { return useContext(CustomerAuthCtx); }

// Customer API wrapper - uses customer token separate from admin
export function customerApi() {
    const tk = localStorage.getItem('dg_customer_token');
    return {
        get: (path, opts = {}) => api.get(path, { ...opts, headers: { ...(opts.headers || {}), ...(tk ? { Authorization: `Bearer ${tk}` } : {}) } }),
        post: (path, body, opts = {}) => api.post(path, body, { ...opts, headers: { ...(opts.headers || {}), ...(tk ? { Authorization: `Bearer ${tk}` } : {}) } }),
        patch: (path, body, opts = {}) => api.patch(path, body, { ...opts, headers: { ...(opts.headers || {}), ...(tk ? { Authorization: `Bearer ${tk}` } : {}) } }),
    };
}
